import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";

const DeleteOrganization = (props) => {

	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const hideModal = () => {
		props.onHide();
	};

	const deleteBtnOnClick = () => {
		RemoveOrganization(props.editData);
	};


    const RemoveOrganization = (_data) => {
		let functionName = "";

		try {
			functionName = props.page + RemoveOrganization.name;

			props.onLoading(true, "Deleting organization, please wait...");
			props.onHide();
			const selectedSystemList = props.editData.SYSTEM_MST_ID === null || props.editData.SYSTEM_MST_ID === undefined ? "" : props.editData.SYSTEM_MST_ID.split(",");
			const data = {
				ORG_ID: _data.ORG_ID,
				ORG_NAME: _data.ORG_NAME,
                ORG_CATEGORY_ID: _data.ORG_CATEGORY_ID,
				ORG_SYSTEM_LIST: selectedSystemList,
			    UPDATE_ID: userId,
			};

			http
				.put("api/Organization/DeleteOrg", data, { timeout: 5000 })
				.then(() => {
					toast.success("Organization is successfully deleted.");
					props.onReload();
				})
				.catch((err) => {
					toast.error("Failed to delete organization. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to delete organization. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	//#endregion

	const message = (
		<>
			Confirm to delete?
			<br />
			Organization :
			{<b> {props.editData !== null && props.editData.ORG_NAME}</b>}
		</>
	);

	return (
		<>
			<Comp.ConfirmModal
				show={props.showHide}
				onHide={hideModal}
				onConfirm={deleteBtnOnClick}
				delete
			>
				{message}
			</Comp.ConfirmModal>
		</>
	);

};

export default DeleteOrganization;